import { render, staticRenderFns } from "./BrickSquareBase.vue?vue&type=template&id=b056352a&scoped=true&"
import script from "./BrickSquareBase.vue?vue&type=script&lang=js&"
export * from "./BrickSquareBase.vue?vue&type=script&lang=js&"
import style0 from "../Style/brick-square-base.scss?vue&type=style&index=0&id=b056352a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b056352a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Projects\\Werk\\MarketingDbNEW\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b056352a')) {
      api.createRecord('b056352a', component.options)
    } else {
      api.reload('b056352a', component.options)
    }
    module.hot.accept("./BrickSquareBase.vue?vue&type=template&id=b056352a&scoped=true&", function () {
      api.rerender('b056352a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/BrickSquareBase.vue"
export default component.exports